import React, { ReactElement } from 'react';
import { saveData } from "services/api/saveData";
import { ModalProps } from "../ModalContext";
import PurchaseModal from '../../../views/purchases/PurchaseModal';

export const handleCreatePurchase = async ({
    itemId,
    initializeModal,
    setFloatingAlert,
    setButtonLoader,
    buttonAction,
    apiObject,
}: {
    itemId: number;
    initializeModal: (content: ReactElement<any>, props?: ModalProps, itemId?: number | null) => void; 
    setFloatingAlert: Function;
    setButtonLoader: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
    buttonAction: string;
    apiObject: string;
}) => {
    try {
        // Start the button loader
        setButtonLoader((prev) => ({ ...prev, [buttonAction]: true }));

        // Link the right object following the apiObject
        const linkedObject = apiObject === 'order' 
            ? { order_id: itemId } 
            : apiObject === 'job' ?  { job_id: itemId } 
            : {};

        // Create the new invoice
        const response = await saveData({
            apiUrl: `post_purchase`,
            method: 'post',
            data: linkedObject
        });

        // Open the new purchase after succesfully creating
        if (response && response.status === 201) {
            const newId = response.data.id;

            if (newId) {
                initializeModal(
                    <PurchaseModal itemId={newId} />,
                    { modalSize: 'large', itemId: newId }
                )
            }

            // Show success alert
            setFloatingAlert({
                type: 'success',
                message: 'validation.purchase.created_successfully',
            });
        }
    } catch (error) {
        setFloatingAlert({
            type: 'danger',
            message: 'validation.purchase.creation_failed',
        });
    } finally {
        // Stop the button loader
        setButtonLoader((prev) => ({ ...prev, [buttonAction]: false }));
    }
};